<template>
    <div>
      <NavSection/>
      <section>
    <div class="portal-top-div">
      <div class="w-layout-blockcontainer portal-tab-container w-container">
        <div class="text-block-914">Hi, {{first_name}}</div>
        <div data-current="Tab 1" data-easing="ease" data-duration-in="300" data-duration-out="100" class="w-tabs">
          <div class="tabs-menu w-tab-menu">
            <a data-w-tab="Tab 1" class="portal-tab w-inline-block w-tab-link" @click.prevent="currentTab='myNewSelf'" :class="currentTab === 'myNewSelf'? 'w--current' : ''">
              <div class="text-block-927">Orders</div>
            </a>
            <a data-w-tab="Tab 2" class="portal-tab w-inline-block w-tab-link" @click.prevent="currentTab='profile'" :class="currentTab === 'profile'? 'w--current' : ''">
              <div>Profile</div>
            </a>
            <a data-w-tab="Tab 3" class="portal-tab w-inline-block w-tab-link" @click.prevent="currentTab='orderInfo'" :class="currentTab === 'orderInfo'? 'w--current' : ''">
              <div>Billing</div>
            </a>
            <a data-w-tab="Tab 3" class="portal-tab w-inline-block w-tab-link" @click.prevent="currentTab='getStarted'" :class="currentTab === 'getStarted'? 'w--current' : ''">
              <div>Quick Start</div>
            </a>
            <a data-w-tab="Tab 3" v-if="hasPrescription" class="portal-tab w-inline-block w-tab-link" @click.prevent="currentTab='prescription'" :class="currentTab === 'prescription'? 'w--current' : ''">
              <div>Dosage</div>
            </a>
            <a data-w-tab="Tab 3" v-if="user.health_id !='' && hasCase" class="portal-tab w-inline-block w-tab-link" @click.prevent="currentTab='talktodoc'" :class="currentTab === 'talktodoc'? 'w--current' : ''">
              <div>Doctor on Demand</div>
            </a>
          </div>
          <div class="w-tab-content">
            <div data-w-tab="Tab 1" class="w-tab-pane" v-show="currentTab === 'myNewSelf'" :class="currentTab === 'myNewSelf'? 'w--tab-active' : ''">
              <myNewSelfSection :user="user" :baseUrl="baseUrl"></myNewSelfSection>
            </div>
            <div data-w-tab="Tab 2" class="w-tab-pane" v-show="currentTab === 'profile'" :class="currentTab === 'profile'? 'w--tab-active' : ''">
              <ProfileSection :user="user" :baseUrl="baseUrl"></ProfileSection>
            </div>
            <div data-w-tab="Tab 3" class="w-tab-pane" v-show="currentTab === 'orderInfo'"  :class="currentTab === 'orderInfo'? 'w--tab-active' : ''">
              <OrderInfoSection :user="user" :baseUrl="baseUrl"></OrderInfoSection>
            </div>
            <div data-w-tab="Tab 3" class="w-tab-pane" v-show="currentTab === 'getStarted'"  :class="currentTab === 'getStarted'? 'w--tab-active' : ''">
              <quickStart :user="user" :baseUrl="baseUrl"></quickStart>
            </div>
            <div data-w-tab="Tab 3" class="w-tab-pane" v-show="currentTab === 'prescription'"  :class="currentTab === 'prescription'? 'w--tab-active' : ''">
              <prescriptionShow :user="user" :baseUrl="baseUrl"></prescriptionShow>
            </div>
            <div data-w-tab="Tab 3" class="w-tab-pane" v-show="currentTab === 'talktodoc'"  :class="currentTab === 'talktodoc'? 'w--tab-active' : ''">
              <talkToDocWindow :user="user" :baseUrl="baseUrl"></talkToDocWindow>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
    </div>
</template>

<script>
import NavSection from '../product/NavSection.vue';
import myNewSelfSection from './myNewSelfSection.vue';
import OrderInfoSection from './orderInfoSection.vue';
import ProfileSection from './profileSection.vue';
import quickStart from './quickStart.vue';
import prescriptionShow from './prescriptionShow.vue';
import talkToDocWindow from './talkToDocWindow.vue';
import {
    mapGetters
} from 'vuex';

export default {
  name: 'HomePage',
  
  components: {
    NavSection,
    myNewSelfSection,
    ProfileSection,
    OrderInfoSection,
    quickStart,
    prescriptionShow,
    talkToDocWindow
  },

  props: ["stripeKey"],

  data() {
    return {
      currentTab: 'myNewSelf',
      baseUrl : process.env.VUE_APP_API_ENDPOINT
    }
  },

  computed: {
    ...mapGetters(['user', 'getLatestPrescription', 'getCase']),
        first_name() {
            try {
                return this.user.first_name;
            } catch (error) {
                console.log(error);
                return "";
            }
        },
        hasPrescription() {
        return !!this.getLatestPrescription;
      },
      hasCase(){
        return !!this.getCase && this.getCase.provider === 1 
      }
  },
  watch: {
    // Reset tab if prescription is removed and current tab is prescription
    hasPrescription(newValue) {
      if (!newValue && this.currentTab === 'prescription') {
        this.currentTab = 'myNewSelf';
      }
    }
  },
  methods: {

  },

  created() {
    window.scroll(0,0)
  }
}
</script>

<style>
.showtab {
  opacity: 1; 
  transition: all, opacity 300ms;
}
.hidetab {
  opacity: 0; 
  transition: all, opacity 300ms;
}
.tabs-menu {
    grid-column-gap: 5px;
    grid-row-gap: 5px;
    border-bottom: 1px solid var(--df-grey);
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1.5fr;
    grid-auto-columns: 1fr;
    padding-bottom: 20px;
    display: grid;
}
@media screen and (max-width: 479px) {
    .tabs-menu {
        grid-column-gap: 5px;
        grid-row-gap: 5px;
        flex-flow: row;
        grid-template-rows: auto auto;
        grid-template-columns: 1fr 1fr 1fr;
        grid-auto-columns: 1fr;
        display: grid;
        overflow: visible;
    }
}

@media screen and (max-width: 479px) {
    .portal-tab {
        border: 1px solid var(--f3-grey);
        text-align: center;
        border-radius: 6px;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        height: 50px;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-right: 0;
        display: flex;
    }
}

.portal-tab {
    background-color: var(--transparent);
    font-family: var(--mulish);
    color: var(--df-grey);
    justify-content: center;
    align-items: center;
    padding-left: 0;
    padding-right: 0;
    font-size: 18px;
    font-weight: 900;
    line-height: 24px;
    display: flex;
}

@media screen and (max-width: 479px) {
    .portal-tab.w--current {
        border-color: var(--pastel-blue);
        display: flex;
    }
}

.portal-tab.w--current {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: var(--transparent);
    font-family: var(--mulish);
    color: var(--black);
    flex-flow: column;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-items: center;
    padding-right: 0;
    font-size: 18px;
    font-weight: 900;
    line-height: 24px;
    display: flex;
}
</style>